import { Alert, Divider } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

function StorePickupOnlyNotification() {
  const { t } = useTranslation('webshop.productPage.storePickup.storePickupOnly');

  return (
    <>
      <Alert title={t('notificationTitle')} description={t('notificationDescription')} />
      <Divider mt={400} mb={400} />
    </>
  );
}

export default StorePickupOnlyNotification;
